import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FilterComponentProp } from '../hocs/types'

const categoryProps: FilterComponentProp = {
    title: 'Category',
    onValueChanged: (values) => {
        return [values, [{ filter: FilterName.sub_style, selected: [] }]]
    },
    renderFilterBar: true,
}

export const Category = withFacetContext(
    FacetName.style,
    withFilterContext(FilterName.style, SearchFiltersDropdown, categoryProps)
)
export const CategoryNoLabel = withFacetContext(
    FacetName.style,
    withFilterContext(FilterName.style, SearchFiltersDropdown, { ...categoryProps, hideLabel: true })
)
